/** Site-wide browser translation protection; DysTest's own language selection is independent. */
let original: { translate: string | null; classPresent: boolean; meta: HTMLMetaElement | null; content: string | null } | null = null;

export function setAssessmentTranslationProtection(enabled: boolean): void {
  const root = document.documentElement;
  if (enabled) {
    if (!original) {
      const meta = document.querySelector<HTMLMetaElement>('meta[name="google"]');
      original = { translate: root.getAttribute('translate'), classPresent: root.classList.contains('notranslate'), meta, content: meta?.getAttribute('content') ?? null };
    }
    root.setAttribute('translate', 'no');
    root.classList.add('notranslate');
    let meta = document.querySelector<HTMLMetaElement>('meta[name="google"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'google';
      meta.setAttribute('data-assessment-translation', '');
      document.head.appendChild(meta);
    }
    meta.content = 'notranslate';
  } else if (original) {
    if (original.translate === null) root.removeAttribute('translate');
    else root.setAttribute('translate', original.translate);
    if (!original.classPresent) root.classList.remove('notranslate');
    document.querySelector('meta[data-assessment-translation]')?.remove();
    if (original.meta) {
      if (original.content === null) original.meta.removeAttribute('content');
      else original.meta.setAttribute('content', original.content);
    }
    original = null;
  }
}
